/* RESPONSIBLE TEAM: team-messenger */
import WorkspaceSettingsRoute from 'embercom/routes/apps/app/settings/base/workspace-settings-route';
import { ReactRoute } from 'embercom/lib/react-route';

class CustomEmojisRoute extends WorkspaceSettingsRoute {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(CustomEmojisRoute);
